<template>
  <div class="complaint" :style="complaintStyle" data-test-id="Complaint" @click="onClick(complaint)">
    <span>{{ complaint.name }}</span>
  </div>
</template>

<script>
import { getContrastColorFor } from "@/Case/services/ColorContrast";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";

export default {
  name: "Complaint",

  props: {
    complaint: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      complaintStyle: {
        "background-color": this.complaint.color,
        color: getContrastColorFor(this.complaint.color),
      },
    };
  },
  methods: {
    onClick(complaint) {
      this.$emit(CaseEvent.MODIFY, { eventType: CaseUpdateEventType.complaint, data: complaint });
    },
  },
};
</script>

<style scoped>
.complaint {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 10px;
  border-radius: 4px;
  word-break: break-word;
  font-weight: bold;
  word-wrap: break-word;
}
</style>
